import { render, staticRenderFns } from "./EventTaskTemplate.vue?vue&type=template&id=2e98ad86"
import script from "./EventTaskTemplate.vue?vue&type=script&lang=js"
export * from "./EventTaskTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports